export default __webpack_public_path__ + "64b8d9d93c792e7748052fcba60bba25.png";